import React, { useEffect, useState } from 'react'
import hoverEffect from 'hover-effect'
import AOS from 'aos'
import 'aos/dist/aos.css'

import fakeflix1 from "../assets/images/netflix-clone.png"
import fakeflix2 from "../assets/images/netflix-clone-2.png"
import meadlight1 from "../assets/images/meadlight.png"
import meadlight2 from "../assets/images/meadlight-2.png"
import googlestories1 from "../assets/images/google-stories.png"
import googlestories2 from "../assets/images/google-stories-2.png"

const Projects = () => {

	const [projContainer] = useState(['.trek', '.kap', '.fin'])

	useEffect(() => {
		AOS.init()

		new hoverEffect({
			parent: document.querySelector('#trek-image'),
			intensity: 0.4,
			image1: fakeflix1,
			image2: fakeflix2,
			displacementImage: 'https://i.imgur.com/CyxD9X6.png',
			angle: Math.PI / 8,
			speedIn: 1.5,
			speedOut: 1.5,
			imagesRatio: 0.5
		})


		new hoverEffect({
			parent: document.querySelector('#kap-image'),
			intensity: 0.4,
			image1: meadlight1,
			image2: meadlight2,
			displacementImage: 'https://i.imgur.com/CyxD9X6.png',
			angle: Math.PI / 8,
			speedIn: 1.5,
			speedOut: 1.5,
			imagesRatio: 0.5
		})

		new hoverEffect({
			parent: document.querySelector('#fin-image'),
			intensity: 0.4,
			image1: googlestories1,
			image2: googlestories2,
			displacementImage: 'https://i.imgur.com/CyxD9X6.png',
			speedIn: 1.5,
			speedOut: 1.5,
			angle: Math.PI / 8,
			imagesRatio: 0.5
		})

		const containers = projContainer.map(element => document.querySelector(element + '-container'))
		let currentPos = window.pageYOffset
		const distort = () => {
			const newPos = window.pageYOffset
			const diff = newPos - currentPos
			const speed = diff * 0.05

			containers.map(element => element.style.transform = `skewY(${speed}deg)`)
			currentPos = newPos
			requestAnimationFrame(distort)
		}
		distort()
	}, [projContainer])

	const show = (event) => {
		event.target.firstChild.innerText = 'CLICK TO EXPLORE APP'
	}

	const remove = (event) => {
		const images = ['honne-image', 'kap-image', 'fin-image']
		const dates = ['15.04.20', '24.03.20', '11.03.20']

		images.map((element, i) =>
			event.target.id === element
				? event.target.firstChild.innerText = dates[i]
				: null
		)
	}

	const ShowcaseLink = () => {
		window.open("https://portfolio-project-showcase.vercel.app/", "_parent").focus();
	}


	return (
		<>
			<div id='para-header'
				data-aos="fade-up"
				data-aos-offset="250"
				data-aos-delay="100"
				data-aos-duration="800"
				data-aos-easing="ease">
				<small>(002)</small> RECENT WORKS
			</div>

			<div className="projects"
				data-aos="fade-up"
				data-aos-offset="250"
				data-aos-delay="100"
				data-aos-duration="800"
				data-aos-easing="ease"
			>
				PROJECTS
			</div>

			<h5 className='text-slider'>
				<span>
					- FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX
					- FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX - FAKEFLIX -
				</span>
			</h5>

			<div className="trek-container">
				<a href="/fakeflix">
					<div data-aos="fade-up" data-aos-offset="300"
						data-aos-duration="800" data-aos-easing="ease"
						onMouseEnter={(e) => show(e)}
						onMouseLeave={(e) => remove(e)} id="trek-image">
						<p> 10.11.21 </p>
					</div>
				</a>

				<img data-aos="fade-up" data-aos-offset="300"
					data-aos-duration="800" data-aos-easing="ease"
					src={fakeflix2}
					alt=""
					loading='lazy'
				/>

				<div data-aos="fade-up" data-aos-offset="300"
					data-aos-duration="1000" data-aos-easing="ease"
					id='proj-text'>

					<h1> FAKEFLIX </h1>
					<div>

					</div>
					<p > <small> PROJECT CONCEPT </small> <br />
						A different type of FAKEFLIX App, with unique design created
						with React.js, SASS and Redux.
						<br /> <br />
						It also implements the animations using Framer Motion, Authentication
						using Firebase and movies list from tmdb.com API.
					</p>
					<br />
					<small> TECHS IMPLEMENTED</small>
					<ul>
						<li> React.js </li>
						<li> SASS </li>
						<li> Redux </li>
						<li> Redux Thunk </li>
						<li> Redux Saga </li>
						<li> Framer Motion </li>
						<li> Firebase </li>
						<li> Axios </li>
						<li> TMDB's API </li>
					</ul>
					<br />
					<a href="/fakeflix">
						<span>SEE MORE...</span>
					</a>
				</div>
			</div >


			<h5 className='text-slider'>
				<span>
					- MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT
					- MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT - MEADLIGHT -
				</span>
			</h5>

			<div className="kap-container">
				<a href="/meadlight">
					<div data-aos="fade-up" data-aos-offset="300"
						data-aos-duration="800" data-aos-easing="ease"
						onMouseEnter={(e) => show(e)}
						onMouseLeave={(e) => remove(e)} id="kap-image">
						<p> 25.11.21 </p>
					</div>
				</a>
				<img data-aos="fade-up" data-aos-offset="300"
					data-aos-duration="800" data-aos-easing="ease"
					src={meadlight2} alt=""
					loading='lazy'
				/>

				<div data-aos="fade-up" data-aos-offset="300"
					data-aos-duration="1000" data-aos-easing="ease"
					id='proj-text'>

					<h1> MEADLIGHT PINKDRINK </h1>
					<div>

					</div>
					<p > <small> PROJECT CONCEPT </small> <br />
						An individual effort in creating a clone of AWWWARDS Site of the Day (#sotd)
						winning website, featuring unique scroll animations of 3D graphics and other
						subtle yet smooth microintractions and animations
						<br /> <br />
						This app was fully designed by me, inspired by the stunning and ever changing design
						of Meadlight's official website
					</p>
					<br />
					<small> TECHS FEATURED </small>
					<ul>
						<li> React.js </li>
						<li> GSAP </li>
						<li> ScrollTrigger </li>
						<li> react-three/fiber </li>
						<li> react-three/drei </li>
						<li> SASS </li>
						<li> Blender (for the 3d Graphics) </li>
					</ul>
					<br />
					<a href="/meadlight">
						<span>SEE MORE...</span>
					</a>
				</div>
			</div >


			<h5 className='text-slider'>
				<span>
					- GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES
					- GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES - GOOGLE STORIES -
				</span>
			</h5>

			<div className="fin-container">
				<a href="/googlestories">
					<div data-aos="fade-up" data-aos-offset="300"
						data-aos-duration="800" data-aos-easing="ease"
						onMouseEnter={(e) => show(e)}
						onMouseLeave={(e) => remove(e)} id="fin-image">
						<p> 15.07.21 </p>
					</div>
				</a>
				<img id='fin-imageTwo' data-aos="fade-up"
					data-aos-offset="300"
					data-aos-duration="800" data-aos-easing="ease"
					src={googlestories2} alt=""
					loading='lazy'
				/>

				<div data-aos="fade-up" data-aos-offset="300"
					data-aos-duration="1000" data-aos-easing="ease"
					id='proj-text'>
					<h1> GOOGLE STORIES </h1>
					<p> <small> PROJECT CONCEPT </small> <br />
						A small project made by me, inspied by the unique animations in Google Stories
						using Gatsby and the animations using GSAP and ScrollTrigger
					</p>
					<br />
					<small> TECHS FEATURED </small>
					<ul>
						<li> React.js </li>
						<li> JavaScript (ES6) </li>
						<li> SASS </li>
						<li> GSAP </li>
						<li> ScrollTrigger </li>
					</ul>
					<br />
					<a href="/googlestories">
						<span>SEE MORE...</span>
					</a>
				</div>
			</div >

			<button className="Button-Creation"
				onClick={ShowcaseLink}
			>
				All Projects...
			</button>
		</>
	)
}

export default Projects